import React, { useEffect } from "react";

declare global {
    interface Window {
        SYNDI: any;
    }
}

interface ProductFeatureComponentProps {
    syndigoId?: string;
    shouldLoad?: boolean; 
}

const ProductFeatureComponent: React.FC<ProductFeatureComponentProps> = ({ syndigoId, shouldLoad = true }) => {
    useEffect(() => {

        if (!shouldLoad || !syndigoId) 
            {return;}

        const src = `https://content.syndigo.com/site/26f69e73-0b23-47d8-6a41-60b701917dba/tag.js?cv=${Math.floor(
            Date.now() / 86400000,
        )}`;
        const script = document.querySelector(`script[src="${src}`);

        if (!script) {
            const scriptElement = document.createElement("script");
            scriptElement.type = "text/javascript";
            scriptElement.async = true;
            scriptElement.src = src;
            scriptElement.id = "26f69e73-0b23-47d8-6a41-60b701917dba";

            const firstScript = document.getElementsByTagName("script")[0];
            if (firstScript) {
                firstScript?.parentNode?.insertBefore(scriptElement, firstScript);
            } else {
                document.head.appendChild(scriptElement);
            }
        }

        window.SYNDI = window.SYNDI || [];
        window.SYNDI.push(syndigoId);
    }, [syndigoId, shouldLoad]);

    return <div id="syndi_inline"></div>;
}

export default ProductFeatureComponent;
